import { Box, Button, Heading, Layer, Paragraph } from "grommet";
import React, { PropsWithChildren } from "react";
export type PopUpProps = PropsWithChildren & {
    setShow: (value: boolean) => void,
    title: string,
    description: string,
    buttonText: string,
  onButtonClick: (event: any) => void,
}

export const PopUp: React.FC<PopUpProps> = (props) => {
    const { setShow, title, description, buttonText, onButtonClick, children } = props;
    return (

        <Layer
            onEsc={() => setShow(false)}
            onClickOutside={() => setShow(false)}
            full={false}
background="cream_constant"
        >
            <Heading margin={{top: "large", bottom: "small", horizontal:"xlarge"}} className="i-bought-one-header" weight="normal" size="38px" color="green_constant" textAlign="center" >
                {title}
            </Heading>
            <Box align="center" alignContent="center" gap="small" pad={{ horizontal: "medium", vertical: "small" }}>

                <Paragraph margin="xsmall">{description}</Paragraph>
                {children}
            </Box>
            <Box margin={{top: "small", bottom: "large", horizontal:"xlarge"}}> <Button label={buttonText} type="submit" onClick={onButtonClick} /></Box>

        </Layer>
    );
}
